"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./index"));



//////////////////
// WEBPACK FOOTER
// ./~/ng2-file-upload/ng2-file-upload.js
// module id = ./node_modules/ng2-file-upload/ng2-file-upload.js
// module chunks = 5